class Sky300VehicleFinder extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const events = { signal: this.controller.signal };
    this.en = this.dataset.language === 'en';
    this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
    this.model = this.querySelector('[data-finder-model]');
    this.year = this.querySelector('[data-finder-year]');
    this.generation = this.querySelector('[data-finder-generation]');
    this.trim = this.querySelector('[data-finder-trim]');
    this.specs = this.querySelector('[data-finder-specs]');
    this.engine = this.querySelector('[data-finder-engine]');
    this.primary = this.querySelector('[data-finder-submit]');
    this.status = this.querySelector('[data-finder-status]');
    this.filter = this.querySelector('[data-finder-filter]');
    this.help = this.querySelector('[data-finder-help]');
    this.initialStatus = this.status.textContent;
    this.catalog = this.primary.getAttribute('href');
    this.initialHelp = this.help.href;
    const cx = 'lo-mejor-para-mazda-cx-30-y-mazda-cx-5';
    const turbo = 'products/reprogramacion-stage-1-skyactiv-turbo-2-5-mazda-6-cx-5-cx-9';
    this.vehicles = [
      ['3','2.0 MZR / All New / Duratec','Mazda 3 2.0 MZR','collections/mazda-3-2-0-mzr'],
      ['3','2.0 Skyactiv','Mazda 3 Skyactiv 2.0','collections/mazda-3-2-0-skyactiv'],
      ['3','2.5 Skyactiv · '+(this.en?'non-turbo':'aspirado'),'Mazda 3 Skyactiv 2.5','collections/mazda-3-2-5-skyactiv'],
      ['6','2.0 / 2.5 Skyactiv · '+(this.en?'non-turbo':'aspirado'),'Mazda 6 Skyactiv','collections/mazda-6-2-5-skyactiv'],
      ['6','2.5 Skyactiv Turbo','Mazda 6 Turbo',turbo,'filtro-de-panel-k-n-alto-flujo-mazda-6-skyactiv'],
      ['CX-3','2.0 Skyactiv-G · '+(this.en?'non-turbo':'aspirado'),'Mazda CX-3 Skyactiv 2.0','collections/'+cx],
      ['CX-30','2.0 Skyactiv-G · '+(this.en?'non-turbo':'aspirado'),'Mazda CX-30 Skyactiv 2.0','collections/'+cx],
      ['CX-30','2.5 Skyactiv-G · '+(this.en?'non-turbo':'aspirado'),'Mazda CX-30 Skyactiv 2.5','collections/'+cx],
      ['CX-5','2.0 / 2.5 Skyactiv · '+(this.en?'non-turbo':'aspirado'),'Mazda CX-5 Skyactiv','collections/'+cx],
      ['CX-5','2.5 Skyactiv Turbo','Mazda CX-5 Turbo',turbo,'filtro-de-panel-k-n-alto-flujo-mazda-cx-5-skyactiv'],
      ['CX-9','2.5 Skyactiv Turbo','Mazda CX-9 Turbo',turbo,'filtro-de-panel-k-n-alto-flujo-mazda-cx-9-skyactiv'],
      ['2','1.5 MZR · All New (no Skyactiv)','Mazda 2 All New 1.5','advice'],
      ['3','2.0 Skyactiv híbrido ligero · MHEV','Mazda 3 Skyactiv 2.0 MHEV','advice'],
      ['CX-30','2.0 Skyactiv híbrido ligero · MHEV','Mazda CX-30 Skyactiv 2.0 MHEV','advice'],
      ['2','1.5 Skyactiv','Mazda 2 Skyactiv 1.5','advice'],
      ['2','2.0 Skyactiv','Mazda 2 Skyactiv 2.0','products/reprogramacion-stage-1-stage1-o-stage2-skyactiv-2-0-mazda-2-mazda-3-6-cx-3-cx-30-cx-5'],
      ['6','2.5 MZR / All New / Duratec','Mazda 6 All New 2.5','products/reprogramacion-stage-1-mazda-6-all-new-2-5'],
      ['CX-50','2.5 Skyactiv · '+(this.en?'non-turbo':'aspirado'),'Mazda CX-50 Skyactiv 2.5','products/filtro-de-panel-k-n-alto-flujo-mazda-cx-50-skyactiv'],
      ['CX-50','2.5 Skyactiv Turbo','Mazda CX-50 Turbo','products/filtro-de-panel-k-n-alto-flujo-mazda-cx-50-skyactiv'],
      ['CX-90','3.3 Turbo MHEV','Mazda CX-90 Turbo MHEV','products/filtro-de-panel-k-n-alto-flujo-mazda-cx-90-skyactiv']
    ];
    // Colombian applications verified in Mazda Colombia manuals and Mazda Packs.
    // End years below are the covered catalog range, not a worldwide production claim.
    this.years = {'2':[2008,2026],'3':[2004,2026],'6':[2003,2020],'CX-3':[2017,2020],'CX-30':[2020,2026],'CX-5':[2012,2026],'CX-9':[2017,2023],'CX-50':[2023,2026],'CX-60':[2023,2026],'CX-90':[2023,2026]};
    this.generations = {
      '2':[['All New / DE (no Skyactiv)',2008,2015],['Skyactiv / DJ-DL',2015,2026]],
      '3':[['Primera generación / BK',2004,2009],['All New / BL',2010,2014],['Skyactiv / BM-BN',2015,2019],['Skyactiv / BP',2020,2026]],
      '6':[['Primera generación / GG-GY',2003,2008],['All New',2009,2013],['Skyactiv',2013,2020]],
      'CX-5':[['Primera generación',2012,2017],['Segunda generación',2017,2026]]
    };
    this.vehicles.push(['6','2.0 / 2.3 MZR · confirmar motor','Mazda 6 Primera generación','advice'],['CX-60','3.3 Turbo híbrido ligero · MHEV','Mazda CX-60 Turbo MHEV','advice'],['CX-60','2.5 híbrido enchufable · PHEV','Mazda CX-60 PHEV','advice']);
    this.model.addEventListener('change', () => {
      this.year.replaceChildren(new Option(this.en ? 'Choose year' : 'Elige el año',''),new Option(this.en ? 'My year is missing / unsure' : 'Mi año no aparece / no estoy seguro','unknown'));
      const range = this.years[this.model.value];
      if (range) for(let y=range[1];y>=range[0];y--) this.year.add(new Option(String(y),String(y)));
      this.year.disabled = !range; this.year.value = ''; this.populateGenerations(); this.populate();
      this.trim.value = ''; this.specs.hidden = true; this.engine.disabled = true;
      window.Sky300Vehicle?.set(''); this.update();
    }, events);
    this.year.addEventListener('change', () => { this.populateGenerations(); this.specs.hidden = !this.year.value; this.refreshEngine(); }, events);
    this.generation.addEventListener('change', () => this.refreshEngine(), events);
    this.trim.addEventListener('input', () => this.update(), events);
    this.engine.addEventListener('change', () => { window.Sky300Vehicle?.set(this.engine.value); this.update(); }, events);
    document.addEventListener('sky300:vehicle-change', (event) => {
      if (event.detail) return;
      // A model change resets only the previous engine, retaining the new model.
      this.engine.value = ''; this.update();
    }, events);
    const saved = this.vehicles.find(v => v[2] === window.Sky300Vehicle?.get());
    if (saved) {
      this.model.value = saved[0]; this.model.dispatchEvent(new Event('change'));
      let details = {}; try { details = JSON.parse(sessionStorage.getItem('sky300_vehicle_details_v1') || '{}'); } catch (_) {}
      this.year.disabled = false; this.year.value = details.vehicle === saved[2] ? details.year || 'unknown' : 'unknown'; if (!this.year.value) this.year.value = 'unknown'; this.populateGenerations();
      if (details.vehicle === saved[2]) { this.generation.value = details.generation || ''; this.trim.value = details.trim || ''; }
      this.populate(); this.specs.hidden = false; this.engine.disabled = false; this.engine.value = saved[2]; window.Sky300Vehicle?.set(this.engine.value); this.update();
    }
  }
  disconnectedCallback() { this.controller?.abort(); }
  populateGenerations() {
    const previous = this.generation.value, year = Number(this.year.value);
    this.generation.replaceChildren(new Option(this.en ? 'Help me identify it' : 'Ayúdenme a identificarla',''));
    const entries = (this.generations[this.model.value] || []).filter(g => !year || (year >= g[1] && year <= g[2]));
    entries.forEach(g => this.generation.add(new Option(g[0],g[0])));
    if (entries.some(g => g[0] === previous)) this.generation.value = previous;
    else if (entries.length === 1) this.generation.value = entries[0][0];
    this.generation.parentElement.hidden = !entries.length;
  }
  populate() {
    this.engine.replaceChildren(new Option(this.en ? 'Choose engine' : 'Elige el motor', ''));
    const generation = this.generation.value;
    const year = Number(this.year.value);
    this.vehicles.filter(v => {
      if (v[0] !== this.model.value) return false;
      if (year && /MHEV/.test(v[2]) && ['3','CX-30'].includes(v[0]) && year < 2022) return false;
      if (year && v[2] === 'Mazda CX-60 PHEV' && year < 2025) return false;
      if (year && v[2] === 'Mazda CX-50 Turbo' && year < 2025) return false;
      if (year && /Turbo/.test(v[2]) && ['6','CX-5'].includes(v[0]) && year < 2019) return false;
      if (v[2] === 'Mazda 2 Skyactiv 2.0') return false; // Modified swaps require individual advice.
      if (v[0] === '6') {
        if (generation.includes('Primera')) return v[2] === 'Mazda 6 Primera generación';
        if (v[2] === 'Mazda 6 Primera generación') return !generation;
      }
      if (v[2] === 'Mazda 3 Skyactiv 2.0 MHEV' && ((year && year < 2022) || /BM-BN|BK|BL/.test(generation))) return false;
      if (this.model.value === '2' && generation) return /All New/.test(generation) === /All New/.test(v[1]);
      if (this.model.value === '3' && generation) return /BK|BL/.test(generation) === /MZR/.test(v[1]);
      if (this.model.value === '6' && generation) return (generation === 'All New') === /All New/.test(v[1]);
      if (this.model.value === 'CX-5' && generation === 'Primera generación' && /Turbo/.test(v[1])) return false;
      return true;
    }).forEach(v => this.engine.add(new Option(v[1], v[2])));
    this.engine.disabled = !this.model.value || !this.year.value;
  }
  refreshEngine() {
    const previous = this.engine.value;
    this.populate();
    if ([...this.engine.options].some(option => option.value === previous)) this.engine.value = previous;
    window.Sky300Vehicle?.set(this.engine.value);
    this.update();
  }
  update() {
    const v = this.vehicles.find(v => v[2] === this.engine.value);
    this.filter.hidden = true;
    this.primary.href = this.catalog;
    this.primary.textContent = this.en ? 'Browse all products' : 'Ver todo el catálogo';
    this.status.textContent = this.initialStatus;
    this.help.href = this.initialHelp;
    delete this.help.dataset.sky300BaseText;
    if (!v) return;
    this.primary.href = v[3] === 'advice' ? this.help.href : this.root + v[3];
    this.primary.textContent = v[4] ? (this.en ? 'View Turbo tuning' : 'Ver reprogramación Turbo') : v[3].startsWith('products/') ? (this.en ? 'View available options' : 'Ver opciones disponibles') : (this.en ? 'Explore this collection' : 'Explorar esta colección');
    this.status.textContent = v[2] + (this.en ? ' selected. Confirm year, generation and the exact variant before ordering.' : ' seleccionado. Confirma año, generación y variante exacta antes de comprar.');
    if (v[4]) {
      this.filter.href = this.root + 'products/' + v[4];
      this.filter.textContent = this.en ? 'View panel filter · confirm variant' : 'Ver filtro de panel · confirmar variante';
      this.filter.hidden = false;
    }
    const context = [this.year?.value && this.year.value !== 'unknown' ? this.year.value : '',this.generation?.value || '',this.trim?.value.trim() || ''].filter(Boolean).join(' · ');
    try { sessionStorage.setItem('sky300_vehicle_details_v1',JSON.stringify({vehicle:v[2],year:this.year?.value || '',generation:this.generation?.value || '',trim:this.trim?.value.trim() || ''})); } catch (_) {}
    document.querySelectorAll('[data-vehicle-label]').forEach(label=>{ label.textContent = v[2] + (context ? ' · ' + context : ''); });
    if (context) this.status.textContent = v[2] + ' · ' + context + (this.en ? '. Confirm exact fitment before ordering.' : '. Confirma compatibilidad exacta antes de comprar.');
    const message = this.en ? `Hello Sky300. My vehicle: ${v[2]}. ${context || 'Year / generation to confirm'}. I need advice on: ____.` : `Hola Sky300. Mi vehículo: ${v[2]}. ${context || 'Año / generación por confirmar'}. Busco asesoría sobre: ____.`;
    this.help.href = 'https://wa.me/573003586097?text=' + encodeURIComponent(message);
    if (v[3] === 'advice') { this.primary.href = this.help.href; this.primary.textContent = this.en ? 'Confirm options with Sky300' : 'Consultar opciones con Sky300'; }
    if (/MHEV|PHEV/.test(v[2])) {
      this.status.textContent += this.en ? ' Sky300 does not offer ECU tuning for hybrids. Parts fitment must be confirmed separately.' : ' Sky300 no realiza reprogramaciones en híbridos. Confirma por separado la compatibilidad de las piezas.';
      if (v[3] === 'advice') this.primary.textContent = this.en ? 'Ask about compatible parts' : 'Consultar piezas compatibles';
    }
  }
}
if (!customElements.get('sky300-vehicle-finder')) customElements.define('sky300-vehicle-finder', Sky300VehicleFinder);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-sky300-load-reel]');
  if (!button) return;
  const frame = document.createElement('iframe');
  frame.src = button.dataset.sky300LoadReel;
  frame.title = button.dataset.title;
  frame.allow = 'autoplay; encrypted-media; picture-in-picture';
  frame.allowFullscreen = true;
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  button.parentElement.classList.add('is-loaded');
  button.replaceWith(frame);
});
